<template>
  <div class="l-main">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form id="reservation-form" @submit.prevent="handleSubmit(toConfirm)">

        <dl class="c-reserve-form--list">
          <div class="c-reserve-form--list--item">
            <dt>お名前<span class="u-must">必須</span></dt>
            <div>
              <dd class="c-padding-bottom">
                <ValidatedInput
                  v-model="data.name" vid="name" placeholder="姓名" type="text" name="姓名" id="name" rules="required" class="inner-input-wrapper"
                />
              </dd>
              <dd>
                <ValidatedInput
                  v-model="data.kana" vid="namekana" placeholder="フリガナ" type="text" name="フリガナ" id="namekana" rules="required" class="inner-input-wrapper"
                />
              </dd>
            </div>
          </div>
          <div class="c-reserve-form--list--item">
            <dt>メールアドレス<span class="u-must">必須</span></dt>
            <div>
              <dd>
                <ValidatedInput
                  v-model="data.email" vid="email" type="text" :expandedTooltip="true" name="メールアドレス" id="email" rules="required|email" class="inner-input-wrapper"
                />
              </dd>
            </div>
          </div>
          <div class="c-reserve-form--list--item">
            <dt>電話番号<span class="u-must">必須</span></dt>
            <div>
              <dd class="-noPadding">
                <div class="c-telephone-field-wrapper">
                  <ValidatedTelephoneField
                    v-model="data.tel" vid="tel" :expandedTooltip="true" type="text" name="電話番号" id="tel" rules="required|phone" class="inner-input-wrapper -marginBottom"
                  />
                </div>
              </dd>
            </div>
          </div>
          <div class="c-reserve-form--list--item" id="c-address-wrapper">
            <dt>資料のお届け先 <span class="u-must">必須</span></dt>
            <div>
              <dd>
                <div class="inner-input-wrapper">
                  <ValidatedZipField
                    v-model="data.zip" type="text" name="郵便番号" id="zip" rules="required|zip" :expandedTooltip="true"
                  />
                </div>
              </dd>
              <dd class="c-reserve-form--list--item__select">
                <PrefCitySelect :prefectureValue="data.pref" :cityValue="data.city" @input-prefecture="data.pref = $event" @input-city="data.city = $event" :prefectureList="prefList"/>
              </dd>
              <dd>
                <ValidatedInput
                  v-model="data.building" placeholder="町名・番地・建物名（住所末尾まで入力）" class="top-margin inner-input-wrapper-long" type="text" name="住所" rules="required"
                />
              </dd>
            </div>
          </div>
        </dl>

        <div class="c-reserve-form--button">
          <common-button
            class="c-reserve-form--button__back"
            :title="'戻る'"
            :border_gray="true"
            :large="true"
            :font_size="'14px'"
            :width="'116px'"
            :attr=[]
            :callback="goBack"
             />

          <common-button
            class="c-reserve-form--button__submit"
            :title="'内容確認に進む'"
            :border_gray="true"
            :large="true"
            :border_only_red="true"
            :bg_red="true"
            :font_size="'14px'"
            :width="'352px'"
            :submit_type="true" />
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import MobileMixin from '@/plugins/isMobile';
import { ValidationObserver } from 'vee-validate';
import ValidatedInput from '@/components/common/validation/ValidatedInput';
import ValidationWrapper from '@/components/common/validation/ValidationWrapper';
import ValidatedZipField from '@/components/common/validation/zip/ValidatedZipField';
import ValidatedTelephoneField from '@/components/common/validation/telephone/ValidatedTelephoneField';
import CommonButton from '@/components/parts/button/CommonButton';
import PrefCitySelect from '@/components/common/PrefCitySelect';

export default {
  name: 'DocumentRequestForm',
  mixins: [MixinAPI, MobileMixin],
  components: {
    ValidationObserver,
    ValidatedInput,
    PrefCitySelect,
    CommonButton,
    ValidatedZipField,
    ValidatedTelephoneField,
    ValidationWrapper,
  },
  props: ['page', 'prefList', 'userData', 'data', 'check', 'err'],
  data() {
    return {
      cityList: [],
      pref: 0,
      city: 0,
      citiesLoading: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
    isPageChild: {
      get() {
        return this.page;
      },
      set(page) {
        this.$emit('input', page);
      },
    },
    verifiedCity() {
      if (!this.cityList) {
        return '';
      }
      const possibleValues = this.cityList.map(c => c.city_name);
      if (!possibleValues.includes(this.data.city)) {
        return '';
      }
      return this.data.city;
    },
  },
  async created() {
    if (!this.data.isLoadedOnce && this.isLoggedIn) {
      // 初回のみデータクローン
      this.data.name = `${this.userData.sei} ${this.userData.mei}`;
      this.data.kana = `${this.userData.seikana} ${this.userData.meikana}`;
      this.data.email = this.userData.email;
      this.data.tel = this.userData.tel;
      this.data.zip = this.userData.zip;
      this.data.pref = this.userData.prefecture;
      this.data.building = this.userData.addressLocal;
      this.data.isLoadedOnce = true;
    }

    if (this.userData.prefecture) {
      await this.getCities(this.userData.prefecture);
      this.data.city = this.userData.address;
    }
  },
  methods: {
    toConfirm() {
      this.isPageChild = 'conf';
    },
    goBack() {
      this.$router.back();
    },
    async getCities(n) {
      try {
        this.data.city = '';
        this.citiesLoading = true;
        this.cityList = null;
        const prefecture = this.prefList.find(item => item.pref_name === n);
        this.cityList = await this.getCityList(0, prefecture.pref_code, 0);
      } catch (e) {
        // console.log(e);
      } finally {
        this.citiesLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/style/contact/form_scss.scss";
button {
  width: 352px;
}

@media(min-width: 768px) {
  .l-main {
      padding: 30px 90px;
  }
}
</style>
